import { combineReducers } from "redux";
import auth from "./auth/authSlice";
import profileIcon from "./Layout/profileIconSlice";
import language from "./Layout/languageSlice";
import Loader from "./Layout/loaderSlice";
import reports from "./Reports/reportsSlice";
import adminAccount from "./Account/accountSlice";
import features from "./PlansFeatures/featuresSlice";
import plans from "./PlansFeatures/plansSlice";
import invoices from "./Invoices/invoicesSlice";
import users from "./Users/usersSlice";
import payments from "./Payments/paymentsSlice";
import companies from "./Companies/companiesSlice";
import submissions from "./Submissions/submissionsSlice";
import teams from "./Teams/teamsSlice";
import jobs from "./Landing/Careers/jobsSlice";
import applicants from "./Landing/Careers/applicantsSlice";
import blogs from "./Landing/Blogs/blogsSlice";
import news from "./Landing/News/newsSlice";
import certificates from "./Landing/CompanyCertificates/companyCertificatesSlice";
import memberships from "./Landing/Memberships/membershipsSlice";
import services from "./Landing/Services/servicesSlice";
import contacts from "./Landing/ContactUs/contactUsSlice";
import faqs from "./Landing/Faqs/faqsSlice";
import ourValues from "./Landing/OurValues/ourValuesSlice";
import newsletterSubscriptions from "./Landing/NewsletterSubscription/newsletterSubscriptionSlice";
import customPages from "./Landing/CustomPages/customPagesSlice";
import customers from "./Landing/Customers/customersSlice";
import partners from "./Landing/Partners/partnersSlice";
import teamMembers from "./Landing/TeamMembers/teamMembersSlice";
import socialMedia from "./Landing/SocialMedia/socialMediaSlice";
import tutorials from "./Landing/Tutorials/tutorialsSlice";
import companyFiles from "./Landing/CompanyFiles/companyFilesSlice";
import coupons from "./Coupons/couponsSlice";
import paymentTypes from "./PaymentTypes/paymentTypesSlice";
import subscriptions from "./Subscriptions/subscriptionsSlice";
import pagesIntroduction from "./Landing/PagesIntroduction/pagesIntroductionSlice";
import landingGeneralSettings from "./Landing/LandingGeneralSettings/landingGeneralSettingsSlice";
import templates from "./Templates/templatesSlice";
import landingSliders from "./Landing/LandingSlider/landingSliderSlice";
import generalSettings from "./GeneralSettings/generalSettingsSlice";
import sitemapUrls from "./Landing/SitemapUrl/sitemapUrlSlice";
import settings from "./Settings/settingsSlice";
import bulkActions from "./BulkActions/bulkActionsSlice";
import rolesPermissions from "./RolesPermissions/rolesPermissionsSlice";
import dsgSettings from "./DsgSettings/dsgSettingsSlice";
import auditLogs from "./AuditLogs/auditLogsSlice";

const rootReducer = combineReducers({
  auth,
  profileIcon,
  Loader,
  language,
  reports,
  adminAccount,
  features,
  plans,
  invoices,
  payments,
  users,
  companies,
  submissions,
  teams,
  jobs,
  applicants,
  blogs,
  news,
  certificates,
  memberships,
  services,
  contacts,
  faqs,
  ourValues,
  newsletterSubscriptions,
  customPages,
  customers,
  partners,
  teamMembers,
  socialMedia,
  tutorials,
  companyFiles,
  coupons,
  paymentTypes,
  subscriptions,
  pagesIntroduction,
  landingGeneralSettings,
  templates,
  landingSliders,
  generalSettings,
  sitemapUrls,
  dsgSettings,
  settings,
  auditLogs,
  bulkActions,
  rolesPermissions,
});

export default rootReducer;
